export const updateLanguage = (language) => {
  return { type: "UPDATE_LANGUAGE", language };
};
